module.exports = __webpack_public_path__ + "img/horizontal_4_5_8017.8b9ee0b4.png";